
import XTable from 'vux/src/components/x-table/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import WxHeader from './Header'
import WxFooter from './Footer'

export default {
directives: {
TransferDom
},
components: {
XTable,
LoadMore,
XButton,
WxHeader,
WxFooter,
Confirm
},
data () {
return {
tag : '缴费中心',
detail_row: {},
call_pay_data: {},
order_no: '',
show_confirm: false,
show_confirm_title: '是否继续缴费?',
show_confirm_content: '每月5-10号为银行自动划扣期，请勿重复缴费',
}
},
mounted () {

this.getOrdersCurDetail();

},
methods: {
payConfirmShow(order_no){
this.show_confirm = true;
},
onShow () {
console.log('on show')
},
onCancel () {
console.log('on cancel')
},
onConfirm (order_no) {
console.log('on confirm')
this.wxpayUnifiedorder(order_no);
},
onHide () {
console.log('on hide')
},
getOrdersCurDetail(){
let order_no = this.$route.query.order_no;
let MemberCenterUrl = '/MemberCenter';
if(!order_no){
this.$router.push({path: MemberCenterUrl});
return;
}
this.order_no = order_no;

let _self = this;
let api_url = this.server_api_url+'service=get_orders_cur_detail';
let formData = {};
let login_data = this.get_login_session_data();
if(!!this.$route.query.order_ycode){
formData.order_ycode = this.$route.query.order_ycode;
}else if(login_data){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
formData.house_id = login_data.house_id;
}else{
this.$router.push({path: MemberCenterUrl});
return false;
}
formData.order_no = order_no;
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
data:formData,

}).then((response) =>{
let data_arr = response.data;
if(data_arr.data.detail_row !== undefined && data_arr.data.detail_row.length > 0){
_self.detail_row = data_arr.data.detail_row[0];
}else if(data_arr.status != '1'){
_self.baseShowModuleAuto(data_arr.msg);
}




}).catch((response) =>{
console.log(response)
})
},
wxpayUnifiedorder(data_order_no){
let order_no = this.$route.query.order_no;
let MemberCenterUrl = '/MemberCenter';

console.log(order_no);
if(!order_no && data_order_no != order_no){
this.baseShowModuleAuto ('非法操作','',2000,MemberCenterUrl)
return;
}

let _self = this;
let api_url = this.server_api_url+'service=wxpay_unifiedorder';
let formData = {};
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
formData.house_id = login_data.house_id;
}else{
this.$router.push({path: MemberCenterUrl});
return false;
}
formData.order_no = order_no;
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,

}).then((response) =>{
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(data_arr.status == '2'){
_self.baseShowModuleAuto(data_arr.msg);
setTimeout(() => {
this.$router.go(0);
}, 2000)

}else{
if(data_arr.data.call_pay_data !== undefined && data_arr.data.call_pay_data.length > 0){
_self.call_pay_data = data_arr.data.call_pay_data;

_self.callpay();
}else{
_self.baseShowModuleAuto(data_arr.msg);
}
}
console.log(_self.call_pay_data.length)


}).catch((response) =>{
console.log(response)
})
},

jsApiCall(){
let _self = this;
WeixinJSBridge.invoke(
"getBrandWCPayRequest",
JSON.parse(this.call_pay_data),
function(res){





_self.updateOrderStatus();
}
);
},
callpay(){

if (typeof WeixinJSBridge == "undefined"){
this.baseShowModuleAuto('请在微信进行支付操作');
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', jsApiCall);
document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
}
}else{
this.jsApiCall();
}
},
updateOrderStatus(){
let MemberCenterUrl = '/MemberCenter';
if(!this.order_no){
this.$router.push({path: MemberCenterUrl});
return;
}
let _self = this;
let api_url = this.server_api_url+'service=update_order_status_by_weixin';
let formData = {};
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
formData.house_id = login_data.house_id;
}else{
this.$router.push({path: MemberCenterUrl});
return false;
}
formData.order_no = this.order_no;
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,

}).then((response) =>{
let data_arr = response.data;
this.baseShowModuleAuto(data_arr.msg);
if(data_arr.status == '1'){
this.$router.go(0);
}
}).catch((response) =>{
console.log(response)
})
},
}
}



// WEBPACK FOOTER //
// ./src/components/PaymentDetail.vue